import React, { createContext, useCallback, useContext, useState } from 'react';
import { LANGUAGE_ITEM_NAME } from './consts/consts';
import { getStoredUuidPathSegment } from './utils/urlUtils';

export enum Languages {
  ENGLISH = 'English',
  HEBREW = 'עברית',
  RUSSIAN = 'Русский',
  ARABIC = 'العربية',
}

type LanguageContextType = {
  language: Languages;
  changeLanguage: (lang: Languages, uuid?: string, persist?: boolean) => void;
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Languages>(Languages.HEBREW);

  const changeLanguage = useCallback((lang: Languages, uuid?: string, persist = true) => {
    setLanguage(lang);
    if (!persist) {
      return;
    }
    const storageUuid = uuid || getStoredUuidPathSegment();
    if (storageUuid) {
      sessionStorage.setItem(`${LANGUAGE_ITEM_NAME}:${storageUuid}`, lang);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const isRTL = (lang: Languages): boolean => {
  switch (lang) {
    case Languages.HEBREW:
    case Languages.ARABIC:
      return true;
    default:
      return false;
  }
};
